import React from 'react';
import { useTranslation } from 'react-i18next';

const ObjectiveActionPlan = ({ actionPlanItems }) => {
    const { t: translate } = useTranslation();
    const orderedItems = [...actionPlanItems].sort((a, b) => a.SortOrder - b.SortOrder);

    return (
        <div>
            <div>{translate('sections.my-objectives.action-plan')}</div>
            <div className="mt-1">
                {orderedItems.map((item) => <div dangerouslySetInnerHTML={{ __html: item.Description }} key={item.ActionPlanItemID} />)}
            </div>
        </div>
    );
};

export default ObjectiveActionPlan;
